import { PAGE_CONTENT_TYPE, REMEDIAL_PAGE_KEY } from "./RemedialQuestionConstants";

export const getPageNumber = (key: any): any => {
  const extractNumber = key.replace(/^\D+/g, "");
  return extractNumber;
};

export const getNumberFromString = (string: string) => {
  const numberList = string.match(/\d+/);
  return numberList ? Number.parseInt(numberList[0]) : 0;
};

export const formatRemedialQuestionApi = (responseObject: any, remedialKey: string, prevRemedialState: any, isRemedialSliceUpdated: boolean) => {
  const { remedialQuestions = [] } = responseObject || {};
  const remedialKeySliceState = prevRemedialState[remedialKey] || {};
  const defaultPageState = {
    page1: {
      question: {
        searchId: '',
        title: '',
        content_Id: '',
        subHeading: '',
        passageId: ''
      },
      pageContentType: PAGE_CONTENT_TYPE.QUESTION
    }
  };
  const pageState = remedialKeySliceState[REMEDIAL_PAGE_KEY.PAGE_STATE] || defaultPageState;

  const remedialState: any = {
    ...prevRemedialState,
    [remedialKey]: {
      ...remedialKeySliceState,
      [REMEDIAL_PAGE_KEY.PAGE_STATE]: {
        ...pageState
      }
    }
  };
  if (isRemedialSliceUpdated) {
    remedialQuestions.forEach((question: any, index: number) => {
      const pageKey = `page${index + 1}`;
      remedialState[remedialKey][REMEDIAL_PAGE_KEY.PAGE_STATE][pageKey] = {
        question: {
          searchId: question.contentId,
          title: question.title,
          content_Id: question.content_Id,
          subHeading: '',
          passageId: question.passageId
        },
        pageContentType: PAGE_CONTENT_TYPE.QUESTION
      };
    });
  }

  return remedialState;
};
